import { ConciergeSearchParams, SearchResult, TopicType } from '../types';
import { SearchFiltersType } from 'app/search/global/type';

const boolTypes = ['highly_rated', 'all_terms'];

const intTypes: { [key: string]: string } = {
    limit: 'limit',
    min_engagement: 'engagement',
    max_engagement: 'engagement_lte',
};

const orderByTypes: { [key: string]: string } = {
    engagement_asc: 'engagement',
    engagement_desc: 'engagement_desc',
    created_date: 'created_date',
    created_date_desc: 'created_date_desc',
    default: 'relevance',
};

export const mapConciergeFilters = (conciergeFilters: ConciergeSearchParams, data: SearchResult[] | null) => {
    const newFilters: Partial<Record<keyof SearchFiltersType, any>> = {
        all_terms: 'Y',
        activeTab: null,
        sort: 'relevance',
        concierge_search: 'Y',
        discoverable: 'Y',
        ignore_columns: 'Y',
    };
    const paramsKeys = Object.keys(conciergeFilters).filter((key) => !['command', 'search_intent'].includes(key));

    const intKeys = Object.keys(intTypes);

    paramsKeys.forEach((key) => {
        if (key === 'is_certified') {
            if (conciergeFilters[key]) {
                newFilters.is_certified = 'Y';
            } else {
                newFilters.is_not_certified = 'Y';
            }
        }
        if (key === 'limit' && conciergeFilters[key]) {
            newFilters.limit = conciergeFilters[key];
        }
        if (boolTypes.includes(key)) {
            newFilters[key as keyof SearchFiltersType] = conciergeFilters[key] ? 'Y' : 'N';
            return;
        }
        if (key === 'include_discoverable_content') {
            newFilters.discoverable = conciergeFilters[key] ? 'Y' : 'N';
            return;
        }
        if (intKeys.includes(key)) {
            newFilters[intTypes[key] as keyof SearchFiltersType] = parseInt(conciergeFilters[key]);
            return;
        }
        if (key === 'created_after') {
            newFilters.created_after = conciergeFilters[key];
            return;
        }
        if (key === 'created_before') {
            newFilters.created_before = conciergeFilters[key];
            return;
        }
        if (key === 'max_engagement') {
            newFilters.engagement_lte = conciergeFilters[key];
            return;
        }
        if (key === 'min_engagement') {
            newFilters.engagement = conciergeFilters[key];
            return;
        }
        if (key === 'filter_by_plugin_ids') {
            newFilters.multiple_plugin_ids = conciergeFilters['filter_by_plugin_ids'];

            return;
        }
        if (key === 'filter_by_category_ids') {
            newFilters.category_id = conciergeFilters[key];

            return;
        }
        if (key === 'filter_by_owner_ids') {
            newFilters.owner_id = conciergeFilters[key];

            return;
        }

        if (key === 'filter_by_source_table_name') {
            newFilters.filter_by_source_table_name = conciergeFilters[key];

            return;
        }

        if (key === 'filter_by_source_table_column_name') {
            newFilters.filter_by_source_table_column_name = conciergeFilters[key];

            return;
        }

        if (key === 'filter_by_topic_ids') {
            newFilters.topic_id = conciergeFilters[key];

            return;
        }
        if (key === 'filter_by_external_content_type_ids') {
            newFilters.external_content_type_ids = conciergeFilters[key];

            return;
        }
        if (key === 'filter_by_folder_ids') {
            newFilters.folder_id = conciergeFilters[key];

            return;
        }
        if (key === 'order_by') {
            const value = conciergeFilters[key];

            if (value && orderByTypes[value]) {
                newFilters.sort = orderByTypes[value];
            }

            return;
        }
        if (key.includes('filter_by_glossary_term_')) {
            const section = key.split('filter_by_glossary_term_')[1];
            const value = conciergeFilters[key];

            const mergedTopics: TopicType = {};

            if (data) {
                for (const element of data) {
                    if (element.tag_types) {
                        for (const [key, value] of Object.entries(element.tag_types)) {
                            const sectionName = key.toLowerCase().replaceAll(' ', '_');

                            if (!mergedTopics[sectionName]) {
                                mergedTopics[sectionName] = [];
                            }
                            const combined = mergedTopics[sectionName].concat(value);
                            const unique = new Map<number, { topic_id: number; name: string }>();

                            for (const item of combined) {
                                unique.set(item.topic_id, item);
                            }

                            mergedTopics[sectionName] = Array.from(unique.values());
                        }
                    }
                }
            }

            if (mergedTopics[section]) {
                const glossaryTerms = mergedTopics[section].filter((item) => {
                    return value.includes(item.name);
                });

                if (glossaryTerms.length > 0) {
                    newFilters.topic_id = glossaryTerms.map((item) => item.topic_id);
                }
            }

            return;
        }
        if (key.includes('filter_by_')) {
            const value = conciergeFilters[key];

            if (!newFilters.custom_fields) {
                newFilters.custom_fields = {};
            }

            let parsedParts;
            if (Array.isArray(value)) {
                for (const valItem of value) {
                    if (valItem && valItem.includes(':')) {
                        parsedParts = valItem.split(':');

                        const [id, ...val] = parsedParts;

                        if (id && val) {
                            if (!newFilters.custom_fields[parseInt(id)]) {
                                newFilters.custom_fields[parseInt(id)] = [];
                            }
                            newFilters.custom_fields[parseInt(id)].push(val.join(':'));
                        }
                    }
                }
            } else {
                parsedParts = value.split(':');

                const [id, val] = parsedParts;

                if (id && val) {
                    newFilters.custom_fields[parseInt(id)] = [val];
                }
            }

            return;
        }
    });

    return newFilters;
};
